import React, { useEffect, useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';
import RevenueCatService from './IOSRevenuecat.js'; // Adjust path as needed

const ANDROID = () => {
  const history = useHistory();
  const hasAttempted = useRef(false); // Prevents duplicate triggers during React Strict Mode
  const [status, setStatus] = useState("Loading...");

    useEffect(() => {
        const handlePaywallFlow = async () => {
            // 1. Prevent double-triggering in React Strict Mode
            if (hasAttempted.current) return;
            hasAttempted.current = true;

            try {
                // 2. Initialize the SDK (Safe to call multiple times)
                await RevenueCatService.initialize();
                
                // 3. Open the native iOS Paywall
                // This waits until the user finishes or closes the window
                const purchased = await RevenueCatService.presentPaywall();

                if (purchased) {
                    // SUCCESS: User bought one of your 3 packages
                    setStatus("Purchase confirmed! Redirecting...");
                    history.push('/android-signup');
                } else {
                    // DISMISSED: User clicked 'X' or swiped down
                    setStatus("Redirecting to login...");
                    history.push('/login');
                }
            } catch (error) {
                console.error("Paywall Flow Error:", error);
                history.push('/login'); // Fallback on error
            }
        };

        handlePaywallFlow();
    }, [history]);

  return (
    <div style={{ 
            backgroundColor: '#202020', 
            height: '100vh', 
            display: 'flex', 
            alignItems: 'center', 
            justifyContent: 'center' 
        }}>
            {/* Dark background to match the iOS system feel during the transition */}
            <p style={{ color: '#fff' }}>Loading...</p>
        </div>
  );
};

export default ANDROID;